import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { registerPwaStart } from '@/shared/lib/pwa';

/** Salva a rota atual quando o app roda como PWA instalado. */
export function PwaEntryTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    registerPwaStart(pathname);
  }, [pathname]);

  return null;
}
